import React, { useState, FocusEvent } from 'react';
import { DateRangeParam } from '../../types/DateRangeParam';
import { formParamsUtils } from '../../utils/formParamsUtils';
import { Row } from '../../grid/Row/Row';
import { Switch } from '../Switch/Switch';
import { BasicControlledRange } from './BasicControlledRange';

type DateRangeWithIsAllDaySwitch = {
  dateRangeParam: DateRangeParam<'daterange'>;
  labelSwitch: string;
  labelStart: string;
  labelEnd: string;
};

export function DateRangeWithIsAllDaySwitch({
  labelSwitch,
  labelStart,
  labelEnd,
  dateRangeParam }: DateRangeWithIsAllDaySwitch) {
  const dateRange = formParamsUtils(dateRangeParam);
  const isAllDayParam = dateRange.getByName('isAllDay');

  const [start, setStart] = useState({
    ...dateRange.getByName('startDate'),
    type: isAllDayParam.checked ? 'date' : 'datetime',
  });
  const [end, setEnd] = useState({
    ...dateRange.getByName('endDate'),
    type: isAllDayParam.checked ? 'date' : 'datetime',
  });

  // used to adapt endDate after startDate is changed by user
  const setEndDateOneHourAfterStartDate = (event: FocusEvent<HTMLInputElement, Element>) => {
    if (event.target.name === start?.name) {
      const date = new Date(event.target.value);
      date.setHours(date.getHours() + 1);
      const tzOffset = (new Date()).getTimezoneOffset() * 60000;
      const localDate = new Date(date.getTime() - tzOffset);

      if (end) {
        setEnd({
          ...end,
          value: localDate.toISOString().replace('.000Z', ''),
        });
      }
    }
  };

  return (
    <>
      <Row>
        <Switch
          label={labelSwitch}
          param={isAllDayParam}
          onChange={(event) => {
            if (start) {
              setStart({
                ...start,
                type: event.target.checked ? 'date' : 'datetime',
              });
            }

            if (end) {
              setEnd({
                ...end,
                type: event.target.checked ? 'date' : 'datetime',
              });
            }
          }}
        />
      </Row>
      <BasicControlledRange
        start={start}
        end={end}
        labelStart={labelStart}
        labelEnd={labelEnd}
        onBlur={setEndDateOneHourAfterStartDate}
        onChange={(event) => {
          if (event.target.name === start?.name) {
            setStart({
              ...start,
              value: event.target.value,
            });
          } else if (event.target.name === end?.name) {
            setEnd({
              ...end,
              value: event.target.value,
            });
          }
        }}
      />
    </>
  );
}
